// extracted by mini-css-extract-plugin
export default {"Practice2Main":"Practice2_Practice2Main__8doB2","Practice2Child":"Practice2_Practice2Child__3j82e"};